// extracted by mini-css-extract-plugin
export default {"AvatarStack":"assignees-group-header-label-module__AvatarStack__lJi2jYe","AggregateLabels":"assignees-group-header-label-module__AggregateLabels__MjdMAOw"};